import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { SlidePanelState } from './types';

const initState = () => {
    return new SlidePanelState();
};

export const useAppSlidePanelModule = createStoreModule<SlidePanelState, IAction<SlidePanelState>>(initState, 'app-slider-panel');
